import React, { Component } from "react";
import PropTypes from "prop-types";
import TruncateMarkup from "react-truncate-markup";
import ToolTipButton from "./tool-tip";
import styled from "styled-components";

const TruncateMarkupContainer = styled.div`
  position: relative;
`;

export class TextEllipsis extends Component {
  render() {
    return (
      <TruncateMarkupContainer>
        <TruncateMarkup
          ellipsis={
            <ToolTipButton
              position={this.props.position}
              toolTipText={this.props.toolTipText}
            />
          }
          lines={this.props.lines}
        >
          {this.props.children}
        </TruncateMarkup>
      </TruncateMarkupContainer>
    );
  }
}

TextEllipsis.propTypes = {
  toolTipText: PropTypes.string,
  lines: PropTypes.number,
  position: PropTypes.string
};

TextEllipsis.defaultProps = {
  lines: 2,
  toolTipText: "",
  position: ""
};
